export default {
    'COMPANY.EDIT.TITLE': 'Edit your account',
};
